module.exports = __webpack_public_path__ + "img/public/siteImages/scanningQrCode.jpg?de89bbb0";